var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStartMenuIcon = function SvgStartMenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D2433",
    fillOpacity: 0.38,
    d: "M22 6v12h-2V6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D2433",
    fillOpacity: 0.6,
    d: "m8 6 1.425 1.4-3.6 3.6H18v2H5.825L9.4 16.6 8 18l-6-6z"
  })));
};
export default SvgStartMenuIcon;